import { AfterViewInit, Component, Input } from "@angular/core";
import { PurchaseLogLineItem } from "@interfaces/purchaseLogLineItem.interface";

@Component({
	moduleId: module.id,
	selector: "purchaseGridDetails",
	styleUrls: ["purchaseGridDetails.css"],
	templateUrl: "purchaseGridDetails.html"
})
export class PurchaseGridDetailsComponent implements AfterViewInit {
	@Input() lineItemData = "";
	lineItems: PurchaseLogLineItem[] = [];
  
	ngAfterViewInit() {
		this.lineItems = JSON.parse(this.lineItemData);
	}
}